module.exports = __webpack_public_path__ + "img/cloth_g1_pants_10.442e042a.svg";